import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=6f7533fe"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"
import style0 from "./Socials.vue?vue&type=style&index=0&id=6f7533fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports